<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import Common from "@/api/services/common.service";
import DomainService from "@/api/services/domain.service";
import SharedElementPagination from "@/components/shared/SharedElementPagination.vue";
import moment from "moment";
import SharedButtonPlus from "@/components/shared/SharedButtonPlus.vue";
import DnsDataTable from "@/views/domain/DnsDataTable.vue";
import DomainHistoryDataTable from "@/views/domain/DomainHistoryDataTable.vue";
import ServerService from "@/api/services/server.service";
import Notification from "@/utils/plugins/NotificationService";

import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useUiStore } from "@/app/stores/uiStore";
import { useTableSort } from "@/app/composables/useTableSort";


const authStore = useAuthStore();
const uiStore = useUiStore();

const instance = getCurrentInstance();

const itemsPerPage = ref("");
const pageSizeOptions = [10, 25, 50, 100, 1000];

const paginationItemsPerPage = computed({
  get() {
    return Number(itemsPerPage.value) || 1000;
  },
  set(value) {
    itemsPerPage.value = value;
  }
});

const params = ref({});

const page = ref(1);

const totalResults = ref(0);

const domainName = ref("");

const customerName = ref("");

const domains = ref([]);

const domainHistory = ref([]);

const domainWeb = ref([]);

const domainDNS = ref([]);

const domainMail = ref([]);

const subdomain = ref("");

const optionsSubdomains = ref([{
  id: 0,
  name: 'No',
  value: false
}, {
  id: 1,
  name: 'Si',
  value: true
}]);

const status = ref("");

const optionsStatus = ref([{
  id: 0,
  name: 'Activo',
  value: 'active'
}, {
  id: 1,
  name: 'Desactivado',
  value: 'disabled'
}, {
  id: 2,
  name: 'Suspendido',
  value: 'suspended'
}
  // {value: "false", text: "No"},
]);

const web = ref("");

const optionsWeb = ref([{
  id: 0,
  name: 'No',
  value: false
}, {
  id: 1,
  name: 'Si',
  value: true
}]);

const dns = ref("");

const optionsDns = ref([{
  id: 0,
  name: 'No',
  value: false
}, {
  id: 1,
  name: 'Si',
  value: true
}]);

const mail = ref("");

const optionsMail = ref([{
  id: 0,
  name: 'No',
  value: false
}, {
  id: 1,
  name: 'Si',
  value: true
}]);

const server = ref("");

const optionsServers = ref([]);

const sortType = ref('');

const domainSortFields = {
  name: "name",
  subdomain: "subdomain",
  status: "status",
  server: "server.name",
  lastUpdate: "lastUpdate",
};

const {
  getSortIcon,
  sortField,
  sortDirection,
  sortItemsLocally: sortDomainsLocally,
  toggleSort,
} = useTableSort();

sortField.value = domainSortFields.name;
sortDirection.value = "ASC";

const sortedDomains = computed(() => sortDomainsLocally(domains.value));

const showDialogDomainHistory = ref(false);

const showDialogWebDetails = ref(false);

const showDialogDnsDetails = ref(false);

const showDialogMailDetails = ref(false);

const user = computed(() => authStore.getUserLogged);

function search() {
  getDomains();
}

function handlePaginationChange(currentPage) {
  page.value = currentPage;
  getDomains();
}

function getDomains() {
  const params = {
    // itemsPerPage: this.itemsPerPage.value,
    page: page.value,
    'order[name]': 'ASC',
    'order[dns.type]': 'ASC',
    'exists[dateEnd]': false,
    'itemsPerPage': 1000
  };
  if (itemsPerPage.value !== undefined && itemsPerPage.value) {
    params['itemsPerPage'] = itemsPerPage.value;
  }
  if (domainName.value) {
    params['name'] = domainName.value;
  }
  if (subdomain.value !== undefined && subdomain.value !== "") {
    params['subdomain'] = subdomain.value;
  }
  if (status.value !== undefined && status.value !== "") {
    params['status'] = status.value;
  }
  if (server.value !== undefined && server.value !== "") {
    params['server.name'] = server.value;
  }
  if (web.value !== undefined && web.value !== "") {
    params['ipActive'] = web.value;
  }
  if (dns.value !== undefined && dns.value !== "") {
    params['dnsInServer'] = dns.value;
  }
  if (mail.value !== undefined && mail.value !== "") {
    params['mxActive'] = mail.value;
  }
  uiStore.startLoading();
  DomainService.getDomains(params).then(response => {
    domains.value = response.data['hydra:member'];
    totalResults.value = response.data["hydra:totalItems"];
    uiStore.stopLoading();
  }).catch(error => {
    console.log(error);
    Notification.addNotification('Error al obtener listado de dominios.', 'error', 6000);
    uiStore.stopLoading();
  });
}

function getServers() {
  const params = {
    itemsPerPage: 1000,
    page: 1,
    'order[name]': 'ASC'
  };
  ServerService.getServers(params).then(response => {
    optionsServers.value = response.data['hydra:member'];
    // console.log("getServers", this.optionsServers);
  }).catch(() => {
    // console.log(e);
    Notification.addNotification('Error al obtener listado de servidores.', 'error', 6000);
  });
}

function ifIsInArray(userRoles, role) {
  // console.log("userRoles", userRoles);
  return Common.ifIsInArray(userRoles, role);
}

function changeOrder(field) {
  toggleSort(field);

  if (!sortField.value || !sortDirection.value) {
    sortField.value = domainSortFields.name;
    sortDirection.value = "ASC";
  }
}

function showModalDomainHistory(domain) {
  // console.log("domain", domain.name)
  domainHistory.value = [];
  const params = {
    itemsPerPage: paginationItemsPerPage.value,
    page: page.value,
    'order[dateStart]': 'ASC',
    'exact_name': domain.name
  };
  uiStore.startLoading();
  DomainService.getDomains(params).then(response => {
    domainHistory.value = response.data['hydra:member'];
    // console.log("domainHistory", this.domainHistory);
    uiStore.stopLoading();
  }).catch(e => {
    console.log(e);
    Notification.addNotification('Error al obtener historial de dominio.', 'error', 6000);
    uiStore.stopLoading();
  });
  showDialogDomainHistory.value = !showDialogDomainHistory.value;
}

function showModalWebDetails(domain) {
  console.log("showModalWebDetails", domain);
  const web = [];
  domain.dns.forEach(obj => {
    if (obj.type === 'A' || obj.type === 'WWW') {
      web.push(obj);
    }
  });
  web.sort((a, b) => {
    return new Date(a.dateStart) - new Date(b.dateStart);
  });
  domainWeb.value = web;
  console.log("this.domainWeb", domainWeb.value);
  showDialogWebDetails.value = !showDialogWebDetails.value;
}

function showModalDnsDetails(domain) {
  const dns = [];
  domain.dns.forEach(obj => {
    if (obj.type === 'NS') {
      dns.push(obj);
    }
  });
  dns.sort((a, b) => {
    return new Date(a.dateStart) - new Date(b.dateStart);
  });
  domainDNS.value = dns;
  // console.log("this.domainDNS", this.domainDNS);
  showDialogDnsDetails.value = !showDialogDnsDetails.value;
}

function showModalMailDetails(domain) {
  const mail = [];
  domain.dns.forEach(obj => {
    if (obj.type === 'MX' || obj.type === 'TXT') {
      mail.push(obj);
    }
  });
  mail.sort((a, b) => {
    return new Date(a.dateStart) - new Date(b.dateStart);
  });
  domainMail.value = mail;
  // console.log("this.domainMail", this.domainMail);
  showDialogMailDetails.value = !showDialogMailDetails.value;
}

function openLinkInNewTab(link) {
  window.open('https://' + link + ':8443', '_blank');
}

function formatDateTime(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
}

function translateTrueOrFalse(value) {
  if (value === 1 || value === true) {
    return "Si";
  } else {
    return "No";
  }
}

function translateStatus(value) {
  if (value.toLowerCase() === 'active') {
    return "Activo";
  } else if (value.toLowerCase() === 'disabled') {
    return "Desactivado";
  } else if (value.toLowerCase() === 'suspended') {
    return "Suspendido";
  }
}

onMounted(() => {
  getDomains();
  getServers();
});
</script>

<template>
  <div v-if="user && (ifIsInArray(user.roles, 'ROLE_ADMIN') || ifIsInArray(user.roles, 'ROLE_SYSTEMS'))"
    id="domain-search">
    <!--    <div class="absences" v-if="user && ifIsInArray(user.roles, 'ROLE_ADMIN')">-->
    <header-title title="Dominios" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/speaker-icon.svg" class=" mx-2" width="30" alt="name-icon" />
      <div class="title-text ml-4">
        DOMINIOS
      </div>
    </div>

    <el-row>
      <el-card class="card-search w-100" body-style="padding:0">
        <div class="row">
          <div class="col-md-4 col-lg-3 col-12">
            <div class="form-item">
              <label for="domain-name" class="w-100">Nombre dominio</label>
              <el-input id="domain-name" v-model="domainName" clearable class="search-input"
                placeholder="Nombre del dominio" @change="search" />
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-12">
            <div class="form-item">
              <label for="id-subdomain" class="w-100">Subdominio</label>
              <el-select v-model="subdomain" clearable placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsSubdomains" :key="item.id" :label="item.name" :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-12">
            <div class="form-item">
              <label for="id-status" class="w-100">Estado</label>
              <el-select v-model="status" filterable clearable placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsStatus" :key="item.id" :label="item.name" :value="item.value" />
              </el-select>
            </div>
          </div>
          <div class="col-md-4 col-lg-3 col-12">
            <div class="form-item">
              <label for="id-server" class="w-100">Servidor</label>
              <el-select v-model="server" filterable clearable placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsServers" :key="item.id" :label="item.name" :value="item.name" />
              </el-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-12">
            <div class="form-item">
              <label for="id-web" class="w-100">Web en el servidor</label>
              <el-select filterable clearable v-model="web" placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsWeb" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <div class="form-item">
              <label for="id-dns" class="w-100">DNS en el servidor</label>
              <el-select filterable clearable v-model="dns" placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsDns" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="col-lg-3 col-12">
            <div class="form-item">
              <label for="id-mail" class="w-100">Correo en el servidor</label>
              <el-select v-model="mail" filterable clearable placeholder="TODOS" @change="search">
                <el-option v-for="item in optionsMail" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </div>
          </div>
          <div class="col-lg-3 col-12 d-flex flex-column justify-content-end domain-search-actions">
            <button class="btn btn_yellow btn-search" @click="search()">
              Buscar
            </button>
          </div>
        </div>
      </el-card>
    </el-row>
    <el-row>
      <div class="table table-domains table-not-mobile">
        <table>
          <thead>
            <tr>
              <th>
                <div class="d-flex justify-content-start align-items-center pointer"
                  @click="changeOrder(domainSortFields.name)">
                  <div>
                    DOMINIO
                    <font-awesome-icon :icon="getSortIcon(domainSortFields.name)" />
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center pointer"
                  @click="changeOrder(domainSortFields.subdomain)">
                  <div>
                    SUBDOMINO
                    <font-awesome-icon :icon="getSortIcon(domainSortFields.subdomain)" />
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center">
                  <div>CLIENTE</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center pointer"
                  @click="changeOrder(domainSortFields.status)">
                  <div>
                    ESTADO
                    <font-awesome-icon :icon="getSortIcon(domainSortFields.status)" />
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center pointer"
                  @click="changeOrder(domainSortFields.server)">
                  <div>
                    SERVIDOR (LINK)
                    <font-awesome-icon :icon="getSortIcon(domainSortFields.server)" />
                  </div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center">
                  <div>WEB</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center">
                  <div>DNS</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center">
                  <div>CORREO</div>
                </div>
              </th>
              <th>
                <div class="d-flex justify-content-start align-items-center pointer"
                  @click="changeOrder(domainSortFields.lastUpdate)">
                  <div>
                    ACTUALIZADO
                    <font-awesome-icon :icon="getSortIcon(domainSortFields.lastUpdate)" />
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="domain in sortedDomains" :key="domain.id">
              <td>
                <div class="d-flex justify-content-start align-items-center">
                  {{ domain.name }}
                  <shared-button-plus @onClick="showModalDomainHistory(domain)" title="Histórico Dominios" />
                </div>
              </td>
              <td>
                <font-awesome-icon class="icon-th" v-if="domain.subdomain" style="color: green;" icon="check-circle" />
                <font-awesome-icon class="icon-th" v-else style="color: red" icon="times-circle" />
              </td>
              <td>
                {{ domain.customerName }}
              </td>
              <td>
                <!--              {{ domain.status | translateStatus }}-->
                <font-awesome-icon v-if="domain.status === 'active'" style="color: green" class="icon-th"
                  icon="check-circle" />
                <font-awesome-icon v-else-if="domain.status === 'disabled'" style="color: red" class="icon-th"
                  icon="times-circle" />
                <font-awesome-icon v-else-if="domain.status === 'suspended'" style="color: orange" class="icon-th"
                  icon="exclamation-circle" />
              </td>
              <td>
                <a :href="'https://' + domain.server.url + ':8443'" @click="openLinkInNewTab(domain.server.url)">
                  <!--              <a v-bind:href="'https://' + domain.server.url + ':8443'" target="_blank" rel="noreferrer noopener">-->
                  {{ domain.server.name }}
                </a>
              </td>
              <td>
                <!--              {{ domain.ipActive | translateTrueOrFalse }}-->
                <div class="pointer" @click="showModalWebDetails(domain)">
                  <font-awesome-icon title="Histórico Web" v-if="domain.ipActive" style="color: green" class="icon-th"
                    icon="check-circle" />
                  <font-awesome-icon title="Histórico Web" v-else style="color: red" class="icon-th"
                    icon="times-circle" />
                </div>
              </td>
              <td>
                <!--              {{ domain.dnsInServer | translateTrueOrFalse }}-->
                <div class="pointer" @click="showModalDnsDetails(domain)">
                  <font-awesome-icon title="Histórico DNS" v-if="domain.dnsInServer" style="color: green"
                    class="icon-th" icon="check-circle" />
                  <font-awesome-icon title="Histórico DNS" v-else style="color: red" class="icon-th"
                    icon="times-circle" />
                </div>
              </td>
              <td>
                <div class="pointer" @click="showModalMailDetails(domain)">
                  <font-awesome-icon title="Histórico Correo" v-if="domain.mxActive" style="color: green"
                    class="icon-th" icon="check-circle" />
                  <font-awesome-icon title="Histórico Correo" v-else style="color: red" class="icon-th"
                    icon="times-circle" />
                </div>
              </td>
              <td>
                {{ formatDateTime(domain.lastUpdate) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-mobile w-100">
        <el-row v-for="domain in sortedDomains" :key="domain.id" class="mt-3">
          <el-card class="domain-mobile-card w-100">
            <div class="domain-mobile-card__header">
              <div class="domain-mobile-card__title">
                {{ domain.name }}
              </div>
              <shared-button-plus @onClick="showModalDomainHistory(domain)" title="HistÃ³rico Dominios" />
            </div>
            <div class="domain-mobile-card__item">
              <span><b class="domain-mobile-card__label">Subdominio:</b>
                {{ translateTrueOrFalse(domain.subdomain) }}</span>
            </div>
            <div class="domain-mobile-card__item">
              <span><b class="domain-mobile-card__label">Cliente:</b>
                {{ domain.customerName || '--' }}</span>
            </div>
            <div class="domain-mobile-card__item">
              <span><b class="domain-mobile-card__label">Estado:</b>
                {{ translateStatus(domain.status) }}</span>
            </div>
            <div class="domain-mobile-card__item">
              <span class="domain-mobile-card__label">Servidor:</span>
              <a class="domain-mobile-card__link" :href="'https://' + domain.server.url + ':8443'"
                @click="openLinkInNewTab(domain.server.url)">
                {{ domain.server.name }}
              </a>
            </div>
            <div class="domain-mobile-card__flags">
              <button class="domain-mobile-flag" type="button" @click="showModalWebDetails(domain)">
                Web: {{ translateTrueOrFalse(domain.ipActive) }}
              </button>
              <button class="domain-mobile-flag" type="button" @click="showModalDnsDetails(domain)">
                DNS: {{ translateTrueOrFalse(domain.dnsInServer) }}
              </button>
              <button class="domain-mobile-flag" type="button" @click="showModalMailDetails(domain)">
                Correo: {{ translateTrueOrFalse(domain.mxActive) }}
              </button>
            </div>
            <div class="domain-mobile-card__item">
              <span><b class="domain-mobile-card__label">Actualizado:</b>
                {{ formatDateTime(domain.lastUpdate) }}</span>
            </div>
          </el-card>
        </el-row>
      </div>
    </el-row>
    <el-row>
      <div class="domain-pagination-wrapper">
        <SharedElementPagination class="pagination" v-model:current-page="page" :total="totalResults"
          v-model:page-size="paginationItemsPerPage" :page-size-options="pageSizeOptions"
          @change="handlePaginationChange" show-always />
      </div>
    </el-row>
    <el-dialog v-model="showDialogDomainHistory" :show-close="false" width="85%">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5"> Histórico del Dominio</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="showDialogDomainHistory = false">
      </div>
      <domain-history-data-table :domain-history="domainHistory" />
      <!--      <employees-with-holidays-new :holidays="holiday"></employees-with-holidays-new>-->
    </el-dialog>
    <el-dialog v-model="showDialogWebDetails" :show-close="false" width="75%">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5"> Servidores WEB</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="showDialogWebDetails = false">
      </div>
      <dns-data-table :dns="domainWeb" />
    </el-dialog>
    <el-dialog v-model="showDialogDnsDetails" :show-close="false" width="75%">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5"> Servidores DNS</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="showDialogDnsDetails = false">
      </div>
      <dns-data-table :dns="domainDNS" />
    </el-dialog>
    <el-dialog v-model="showDialogMailDetails" :show-close="false" width="75%">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5"> Servidores de Correo</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="showDialogMailDetails = false">
      </div>
      <dns-data-table :dns="domainMail" />
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
#domain-search {
  .title-text {
    text-align: center;
    align-self: center;

    font-size: 3em;
    font-weight: 900;
    letter-spacing: -0.05em;
    color: $font-blue-color;
  }

  .card-search {
    border-radius: 15px;
    height: 250px;
    background: url("../../assets/icons/altavoz.png"), white;
    background-repeat: no-repeat;
    background-position-x: 100%;
    overflow: visible !important;
  }

  #icon-search {
    fill: $bg-blue;
    width: 6%;
  }

  .label-common {
    label {
      font-size: 20px;
      font-weight: 800;
      letter-spacing: -2px;
    }
  }

  .table-domains {
    width: 100%;

    table {
      table-layout: fixed;

      thead {
        tr {
          th {
            padding: 0px !important;
            margin: 0px !important;
          }
        }

        #icon-search {
          fill: $bg-blue;
          width: 2.9em;
        }

        #icon-user {
          fill: $bg-blue;
          width: 1.6em;
        }
      }

      tbody {
        td {
          .link-name {
            margin: auto;
            margin-left: 10px;
          }

          &:first-child,
          &:nth-child(3),
          &:nth-child(5) {
            word-break: break-word;
          }
        }
      }
    }
  }

  @media (max-width: 1486px) and (min-width: 768px) {
    .table-domains {
      margin-top: 12px;

      table {
        th {
          font-size: 14px;
          line-height: 1.15;
          padding: 8px 6px !important;
          overflow-wrap: anywhere;
        }

        tbody {
          td {
            font-size: 14px;
            line-height: 1.2;
            padding: 9px 6px !important;
            overflow-wrap: anywhere;

            a {
              font-size: 14px;
            }

            .icon-th {
              font-size: 16px;
            }
          }

          td:first-child > .d-flex {
            flex-wrap: wrap;
            gap: 4px;
          }
        }

        th:nth-child(1),
        td:nth-child(1) {
          width: 20%;
        }

        th:nth-child(2),
        td:nth-child(2) {
          width: 8%;
        }

        th:nth-child(3),
        td:nth-child(3) {
          width: 15%;
        }

        th:nth-child(4),
        td:nth-child(4) {
          width: 7%;
        }

        th:nth-child(5),
        td:nth-child(5) {
          width: 14%;
        }

        th:nth-child(6),
        td:nth-child(6),
        th:nth-child(7),
        td:nth-child(7) {
          width: 6%;
        }

        th:nth-child(8),
        td:nth-child(8) {
          width: 8%;
        }

        th:nth-child(9),
        td:nth-child(9) {
          width: 16%;
        }
      }
    }
  }

  .close-icon {
    width: 30px;
    height: 30px;
  }

  #asterisk {
    position: absolute;
    vertical-align: super;
    height: auto;
    width: 2.2em;
    fill: #f9156f;
  }

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .text-header {
    text-align: left;
    font-size: 4em;
    font-weight: 900;
    letter-spacing: -0.05em;
    color: #f9156f;
  }

  .table-mobile {
    display: none;
  }

  .domain-pagination-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    padding: 0 0 20px;
  }

  .domain-search-actions {
    padding-top: 24px;
  }

  .domain-search-actions .btn-search {
    min-height: 44px;
    margin-bottom: 0 !important;
    width: 100%;
  }

  .domain-mobile-card {
    border-radius: 18px;
  }

  .domain-mobile-card :deep(.el-card__body) {
    padding: 18px 18px 20px;
  }

  .domain-mobile-card__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 14px;
  }

  .domain-mobile-card__title {
    color: $bg-blue;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    word-break: break-word;
  }

  .domain-mobile-card__item {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-bottom: 12px;
    word-break: break-word;
  }

  .domain-mobile-card__label {
    color: $bg-blue;
    font-weight: 800;
  }

  .domain-mobile-card__link {
    color: #f9156f;
    font-weight: 700;
    text-decoration: none;
  }

  .domain-mobile-card__flags {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 12px;
  }

  .domain-mobile-flag {
    width: 100%;
    border: 1px solid #d7daf5;
    border-radius: 14px;
    background: #f6f7ff;
    color: $bg-blue;
    font-weight: 700;
    text-align: left;
    padding: 10px 12px;
  }

  @media (min-width: 768px) {
    .table-mobile {
      display: none;
    }
  }

  @media (max-width: 767px) {
    .title-text {
      font-size: 2.2em;
    }

    .card-search {
      height: auto;
      padding: 18px 16px;
      background-size: 90px;
      background-position: calc(100% + 18px) 12px;
    }

    .domain-search-actions {
      padding-top: 0;
    }

    .domain-search-actions .btn-search {
      width: 100%;
      margin-top: 8px;
    }

    .domain-pagination-wrapper {
      justify-content: center;
      gap: 8px;
    }

    .table-not-mobile {
      display: none;
    }

    .table-mobile {
      display: block;
      padding-right: 0;
      padding-left: 0;
    }

    .my-header {
      gap: 10px;
      align-items: flex-start;
    }

    .text-header {
      font-size: 2em;
      padding-left: 24px;
      line-height: 1.1;
    }

    .close-icon {
      width: 24px;
      height: 24px;
      min-width: 24px;
    }
  }
}
</style>
